module.exports = __webpack_public_path__ + "static/img/icon23.7033f5d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon23.png
// module id = rWE0
// module chunks = 1